module.exports = __webpack_public_path__ + "img/img-average-driver-rating.247ab509.svg";